import React from 'react';

import '../css/postLayout.css';
import '../css/postDetail.css';
import { formatDate } from '../../../../format/formatDate';
import UsePostDetailHelmet from '../../../../helmet/UsePostDetailHelmet';

// const extractHeadingsStructured = (html) => {
//   const parser = new DOMParser();
//   const doc = parser.parseFromString(html, 'text/html');

//   const headings = [];
//   let currentH1 = null;
//   let currentH2 = null;

//   doc.querySelectorAll('h1, h2, h3').forEach((heading, index) => {
//     const id = `heading-${index}`;
//     heading.setAttribute('id', id);

//     if (heading.tagName === 'H1') {
//       // Tạo một mục mới trong danh sách mục lục
//       currentH1 = {
//         id,
//         title: heading.textContent.trim(),
//         subHeadings: [],
//       };
//       headings.push(currentH1);
//       currentH2 = null; // Reset cấp nhỏ hơn
//     } else if (heading.tagName === 'H2') {
//       const newH2 = {
//         id,
//         title: heading.textContent.trim(),
//         subHeadings: [],
//       };
//       if (currentH1) {
//         currentH1.subHeadings.push(newH2);
//       } else {
//         headings.push(newH2); // Nếu không có H1, H2 vẫn được thêm vào danh sách chính
//       }
//       currentH2 = newH2;
//     } else if (heading.tagName === 'H3' && currentH2) {
//       currentH2.subHeadings.push({
//         id,
//         title: heading.textContent.trim(),
//       });
//     }
//   });

//   return headings;
// };
const PostDetail = ({ data, slug, breadcrumb }) => {
  // const [hidenTable, setHidenTable] = useState(false);

  // const tableOfContents = extractHeadingsStructured(data?.content);

  return data ? (
    <>
      {data && (
        <UsePostDetailHelmet post={data} slug={slug} breadcrumb={breadcrumb} />
      )}
      <div className="bg-white shadow-lg mb-3 post-detail">
        <div className="card">
          <div className="card-body">
            <h1>{data.title}</h1>
          </div>
        </div>
        <div className="meta-icon mt-2">
          <div className="row">
            <div className="col-12 col-lg-9 ">
              {/* <div className="author d-inline-flex me-3 ">
              <i className="fas fa-user"></i>
              <span className="ms-2">{data.author.full_name}</span>
            </div>*/}
              <div className="update-time  d-inline-flex">
                <i className="fas fa-calendar-alt"></i>
                <span className="ms-2" id="update-time">
                  {formatDate(data.created_at)}
                </span>
              </div>
            </div>
            <div className="col-12  col-lg-3 "> </div>
          </div>
        </div>

        <div className="d-flex article-detail flex-column flex-lg-row ">
          {/* <div className="social-icons  d-lg-block">
          <a
            href="https://www.facebook.com/"
            className="fb-xfbml-parse-ignore d-inline"
            rel="noopener"
            title="Chia sẻ trên Facebook"
          >
            <img src="/images/post/facebook.png" alt="" className="d-block" />
          </a>
          <a
            href="https://www.instagram.com/"
            alt=""
            rel="noopener"
            className="d-inline"
            title="Chia sẻ trên Instagram"
          >
            <img src="/images/post/instagram.png" alt="" className="d-block" />
          </a>
        </div>*/}

          <div className="content" id="content">
            <article>
              {/*tableOfContents.length > 0 && (
              <div className="table-of-contents">
                <p className="title">
                  Mục lục
                  <span
                    className="px-2"
                    onClick={() => setHidenTable(!hidenTable)}
                    data-action="hide"
                  >
                    [Ẩn]
                  </span>
                </p>
                <div
                  className="toc-hierarchy"
                  style={{ display: hidenTable ? 'none' : 'block' }}
                >
                  <ul>
                    {tableOfContents.map((item, index) => (
                      <li key={index}>
                        <span
                          style={{
                            cursor: 'pointer',

                            textDecoration: 'underline',
                          }}
                          onClick={() =>
                            document
                              .getElementById(item.id)
                              ?.scrollIntoView({ behavior: 'smooth' })
                          }
                        >
                          {item.title}
                        </span>
                        {item.subHeadings.length > 0 && (
                          <ul style={{ marginLeft: '20px' }}>
                            {item.subHeadings.map((subItem, idx) => (
                              <li key={idx}>
                                <span
                                  style={{
                                    cursor: 'pointer',
                                    textDecoration: 'underline',
                                  }}
                                  onClick={() =>
                                    document
                                      .getElementById(subItem.id)
                                      ?.scrollIntoView({ behavior: 'smooth' })
                                  }
                                >
                                  {subItem.title}
                                </span>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )*/}

              {data?.content ? (
                <div dangerouslySetInnerHTML={{ __html: data?.content }} />
              ) : (
                <p>Không có nội dung.</p>
              )}
            </article>
          </div>
        </div>
      </div>
    </>
  ) : (
    <div className="bg-white shadow-lg mb-3 no-post">
      <p>Không có dữ liệu bài viết.</p>
    </div>
  );
};

export default PostDetail;
